import { useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { useUnit } from 'effector-react';
import { $user, setUser } from 'models/user';

const useUserProfile = (onSuccess?: () => void) => {
  const { keycloak } = useKeycloak();
  const user = useUnit($user);

  useEffect(() => {
    const loadUserData = async () => {
      if (keycloak.authenticated && !user && keycloak.token) {
        try {
          const userProfile = await keycloak.loadUserInfo();
          if (userProfile && keycloak && keycloak.tokenParsed) {
            setUser({ ...keycloak.tokenParsed, ...userProfile });
            onSuccess?.();
          }
        } catch (error) {
          console.error('Ошибка при загрузке данных пользователя:', error);
          keycloak?.logout();
        }
      }
    };
    loadUserData();
  }, [keycloak.authenticated, keycloak.token, user, onSuccess]);

  return { user, keycloak };
};

export default useUserProfile;
